import { render, staticRenderFns } from "./prompt-media-cancel.vue?vue&type=template&id=7ca6652e"
var script = {}
import style0 from "./prompt-media-cancel.vue?vue&type=style&index=0&id=7ca6652e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports